module.exports = __webpack_public_path__ + "static/media/lb.9d9481f9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lb.svg
// module id = 2139
// module chunks = 0